module.exports = __webpack_public_path__ + "static/media/lv_sparkling_blood_orange.fde1e9a9.png";